/** ***
------------------------------------------------------------------------
RULES LIST PAGE
------------------------------------------------------------------------
  Rule Name (Rule Name)
  Rule Description (Rule Description)
  Rule Type (Rule Type - Edge, Path, Cluster, etc.)
  Severity (High, Medium, Low)
  Risk Score (absolute score)
  Risky Trail Augmentation (Yes, No. defaults to No)
  Augmented Score (score when trigered on a risky trail)
  Kill Chain Tactic
  Applicable OS
  Created On
  Last Modified On

  anchor: false
  category: "DISCOVERY"
  depends: null
  depth: 5
  enabled: true
  expressions: ["#uses and #riskyTrail and %userQueryFiles.contains(artifactPath)"]
  frequency: 0
  hits: 0
  id: "1"
  iocCategory: "DISCOVERY"
  iocDepends: "NONE"
  name: "queried active users"
  options: {}
  os: "linux"
  output: "risky trail - #{sourceProcessName} queried for active users"
  recommendations: []
  requisites: []
  ruleScore: "MEDIUM"
  score: "MEDIUM"
  triggerLimit: 0
  triggerLimitWindow: "HOUR"
  triggerLimitWindowEnum: "HOUR"
  type: "edge"
  useoutput: false
  uuid: null

** ***/
const rulesListMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'number',
        description: 'Rule ID',
        label: 'Rule ID',
        'min-width': 100,
        sortable: true,
        name: 'id'
      },
      {
        datatype: 'string',
        description: 'Rule Name',
        label: 'Rule Name',
        'min-width': 200,
        sortable: true,
        name: 'name'
      },
      {
        datatype: 'number',
        description: 'Absolute score',
        label: 'Risk Score',
        'min-width': 150,
        sortable: true,
        name: 'ruleScore'
      },
      {
        datatype: 'objectpath',
        description: 'Cyber Kill Chain Tactic',
        label: 'ATT&CK Tactic',
        sortable: false,
        name: 'killChainData',
        display: 'component',
        displayTextName: 'displayTactic',
        component: 'CyberKillChainTickChart',
        componentKey: 'id',
        link: 'externalTacticUrl',
        'min-width': 300
      },
      {
        datatype: 'string',
        description: 'Status',
        label: 'Status',
        'min-width': 100,
        sortable: true,
        name: 'enabledText',
        display: 'colorTag',
        displayKey: [
          {
            key: 'ACTIVE',
            display: 'Active',
            color: '#b0e9d1',
            textColor: '#00602e'
          },
          {
            key: 'DISABLED',
            display: 'Disabled',
            color: '#f8fcff',
            textColor: '#6a6e75'
          }
        ]
      }
    ]
  }
}

export { rulesListMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/rules/ruleslist-meta.js